module.exports = __webpack_public_path__ + "img/security-0-supp.9402245d.png";